import React, { useRef, useEffect, useState } from "react";

interface PiPWrapperProps {
  stream: MediaStream | null;
  children: React.ReactNode;
  autoStart?: boolean;
}

const PiPWrapper: React.FC<PiPWrapperProps> = ({
  stream,
  children,
  autoStart = true,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [pipEnabled, setPipEnabled] = useState(false);
  console.log("pip", pipEnabled)
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream);
  }, []);

  // Attach the stream to the hidden video element
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  const enablePiP = async () => {
    const video = videoRef.current;
    if (!video) return;

    try {
      if (document.pictureInPictureElement !== video) {
        await video.requestPictureInPicture();
        setPipEnabled(true);
        console.log("PiP started!");
      }
    } catch (err) {
      console.error("Failed to enable PiP:", err);
    }
  };

  const disablePiP = async () => {
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
        setPipEnabled(false);
        console.log("PiP closed!");
      }
    } catch (err) {
      console.error("Failed to exit PiP:", err);
    }
  };

  // Auto-start PiP when user switches tabs
  useEffect(() => {
    if (!autoStart || isIOS) return;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        enablePiP();
      } else {
        disablePiP();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [stream, isIOS]);

  return (
    <>
      {/* Hidden video for PiP */}
      <video
        ref={videoRef}
        className="absolute w-[1px] h-[1px] opacity-0 pointer-events-none"
        autoPlay
        playsInline
        muted
      />

      {/* Render child directly, no layout-breaking wrapper */}
      {children}

      {/* Manual PiP button */}
      {/* {(isIOS || !pipEnabled) && (
        <button
          onClick={enablePiP}
          className="absolute top-2 right-2 bg-black/70 text-white px-3 py-1 rounded-lg text-sm shadow-lg "
        >
          {isIOS ? "Enable Video" : "Enable Video"}
        </button>
      )} */}
    </>
  );
};

export default PiPWrapper;
